<template>
  <div class="about-us-wrapper">
    <div class="journal-top clearfix">
      <div class="jonaral-left">
        <!-- <search></search> -->
      </div>
      <div class="nav-wrapper">
        <span>当前位置：</span>
        <span class="active">{{text}}</span>
      </div>
    </div>
    <div class="con-center">
      <!-- <item-detail :detail="detail" :detailShow="detailShow"></item-detail> -->

  <div class="common-detail" v-for="(itemBig,index) in detail" :key="index">
    <div class="title">{{itemBig.title}}</div>
    <video class="videoFw" v-show="itemBig.videoflag=='true'" ref="videoRef" controls="controls" :src="itemBig.video"></video>
    <div class="article-content ql-editor" v-html="itemBig.content">

    </div>
        <div class="article-content">
      <div v-for="(item,index) in itemBig.files" :key="index">
        <p class="ql-file"><a :href="item.url">{{item.name}}</a></p>
      </div>
    </div>
      <div class="con-line" v-if="index<detail.length - 1">

  </div>
  </div>

  <!-- <div class="common-detail" v-if="detail.title2">
    <div class="title">{{detail.title2}}</div>
    <div class="article-content ql-editor" v-html="detail.content2">

    </div>
        <div class="article-content">
      <div v-for="(item,index) in detail.file_url2" :key="index">
        <a :href="item.url">{{item.name}}</a>
      </div>
    </div>
  </div> -->
    </div>
  </div>
</template>
<script>
import search from "@/components/views/common/search.vue";
import itemDetail from "@/components/views/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      detailShow: false,
      detail: []
    };
  },
  computed: {
    text() {
      if (this.$route.query.type == 1) {
        return "计量检测委托业务";
      } else {
        return "质量管理信息填报";
      }
    }
  },
  mounted() {
    this.conDetail();
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    conDetail() {
      userApi.multipleinfo({type:this.$route.query.type}).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    search,
    itemDetail
  },
  watch:{
    $route() {
      this.conDetail();
    }
  }
};
</script>

<style scoped>
.videoFw{
  width:600px;
  height: 400px;
  display: block;
  margin: 0 auto;
  margin-bottom: 20px;
}
.con-line{
  width: 100%;
  height: 2px;
  background: #dcdcdc;
  margin: 50px auto;
}
.about-us-wrapper {
  width: 1240px;
  margin: 0 auto;
}
.jonaral-left {
  width: 310px;
  margin-right: 30px;
  float: left;
}
.nav-wrapper {
  font-size: 0;
  margin-bottom: 30px;
}
.nav-wrapper span {
  font-size: 16px;
  color: #212121;
  line-height: 40px;
}
.active {
  color: #194eb0 !important;
  cursor: pointer;
}
.padd {
  padding: 0 4px;
}
.con-center {
  width: 100%;
  border-width: 20px 1px 20px 1px;
  border-color: #e6ecf2;
  border-style: solid;
  border-radius: 10px;
  padding: 50px 199px;
  box-sizing: border-box;
}
.common-detail .title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
  line-height: 35px;
}

.article-content /deep/ img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}
.article-content /deep/ video {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}
.ql-file{
  padding: 8px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/conUs/multipleinfo.vue